import styled from 'styled-components';

export const ScTerms = styled.div`
  color: white;
  font-weight: normal;
  font-size: 12px;
  text-transform: none;

  & .term__head {
    cursor: pointer;
    font-size: 14px;
    margin-bottom: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: '';
      width: 12px;
      height: 12px;
      background-image: url('/images/arrow.svg');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      display: inline-block;
      vertical-align: middle;
      margin-left: 6px;
    }
  }

  & ol {
    text-align: left;
    padding: 0 64px;
    padding-bottom: 3.25rem;
  }
`;
